// src/redux/mappers/Export/exchangeRateMapper.js

// 🔹 GET Response → Frontend
export const mapExchangeRateResponse = (data) => {

  if (!data?.exchangeRates || !Array.isArray(data.exchangeRates)) {
    console.warn("⚠️ exchangeRates missing or not array:", data?.exchangeRates);
    return [];
  }

  return data.exchangeRates.map((item, index) => {

    const mapped = {
      exportExchangeRateId: data.exportExchangeRateId || "",
      id: item.code || "",
      code: item.codeName || "",
      codeName: item.codeName || "", // keep separate for clarity
      custExchRate: Number(item.custom?.custExchRate ?? 0),
      nonStdCurr: "Bank Details", // static placeholder
      exRate: Number(item.custom?.exRate ?? 0),
      cfx: Number(item.custom?.cfx ?? 0),
      exRateCfx: Number(item.custom?.exRate ?? 0), // duplicate mapping
      agentExRate: Number(item.revenue?.agentExRate ?? 0),
      cfxAgent: Number(item.revenue?.cfx ?? 0),
      exRateCost: Number(item.cost?.exRate ?? 0),
      cost: Number(item.cost?.exRate ?? 0),
    };

    return mapped;
  });
  
};


export const mapExchangeRateRequest = (rates = {}) => {
  if (typeof rates !== "object" || rates === null) {
    return { exchangeRates: [] };
  }

  const exchangeRates = Object.entries(rates)
    .map(([code, values]) => {
      // ❌ Skip invalid or empty keys
      if (code === "general" || code === "exchRate") return null;

      const mapped = { code };

      // Normalize keys
      const exRate = values.exRate ?? values.exrate;
      const agentExRate = values.agentExRate ?? values.agentexrate;
      const cost = values.cost ?? values.Cost;
      const custExchRate = values.custExchRate ?? values.custexchrate;

      // ✅ CUSTOM
      if (custExchRate != null) {
        mapped.custom = { custExchRate: Number(custExchRate) };
      }

      // ✅ REVENUE
      if (exRate != null || agentExRate != null) {
        mapped.revenue = {};
        if (exRate != null) mapped.revenue.exRate = Number(exRate);
        if (agentExRate != null) mapped.revenue.agentExRate = Number(agentExRate);
      }

      // ✅ COST
      if (cost != null) {
        mapped.cost = { exRate: Number(cost) };
      }

      // ✅ Return only if at least one section exists
      const hasValidData = mapped.custom || mapped.revenue || mapped.cost;
      return hasValidData ? mapped : null;
    })
    .filter(Boolean); // removes null rows

  return { exchangeRates };
};
